module.exports = __webpack_public_path__ + "media/camera-shutter-click-08.a2984828.mp3";